/**
 * Uses the Vue-i18n library: http://kazupon.github.io/vue-i18n/introduction.html#sponsors
 *
 * Translations are stored at: https://docs.google.com/spreadsheets/d/1J5RxYvDZOnI86uSkao-EWSHs0YztjmUodJo8RFUo53w/edit#gid=0
 * and converted into locale json in @/locales using 'npm run translations'
 *
 * This really should be changed to load translations at runtime at some point.
 */

// START OF VUE 2 //
import Vue from "vue";
import type { Locale, Path } from "vue-i18n";
import VueI18n from "vue-i18n";
import enMessages from "@/locales/en.json";
import assertLogger from "@/app/eventlogging/assertLogger";

const defaultLanguageLocale = "en";

Vue.use(VueI18n);

const i18n = new VueI18n({
  missing: (locale: Locale, key: Path, vm: Vue | null, values: any) => {
    // We don't always want to create tooltip text so default to empty string if not found.
    if (key.endsWith("_hint")) {
      return "";
    }
    assertLogger.logViolation("Missing Translation : " + key);
    return key.replace(/_/g, " ");
  },
  // Prevents warnings in dev build for missing translations
  silentTranslationWarn: true,

  // Apply 'en' defaults
  locale: defaultLanguageLocale,
  fallbackLocale: defaultLanguageLocale,
  messages: {
    en: enMessages,
  },
});

const setCorei18nLocale = (languageLocale: string) => {
  i18n.locale = languageLocale;
};

const setCorei18nLocalMessage = (langLocale: string, messages: any) =>
  i18n.setLocaleMessage(langLocale, messages);

const corei18nt = (keyString: string, values?: Record<string, any>) =>
  i18n.t(keyString, values);

export const i18nCore = {
  i18n,
  setCorei18nLocale,
  setCorei18nLocalMessage,
  corei18nt,
};

// END OF VUE 2 //

/* START OF VUE 3 //

import type { Locale, Path } from "vue-i18n";
import { createI18n } from "vue-i18n";
import assertLogger from "@/app/eventlogging/assertLogger";
import enMessages from "@/locales/en.json";

const defaultLanguageLocale = "en";

const i18n = createI18n({
  // Use legacy: false to enable Composition API mode
  legacy: false,

  // This is the new equivalent of 'silentTranslationWarn: true'
  missingWarn: false,
  fallbackWarn: false,

  missing: (locale: Locale, key: Path) => {
    // We don't always want to create tooltip text so default to empty string if not found.
    if (key.endsWith("_hint")) {
      return "";
    }
    assertLogger.logViolation("Missing Translation : " + key);
    return key.replace(/_/g, " ");
  },

  locale: defaultLanguageLocale,
  fallbackLocale: defaultLanguageLocale,
  messages: {
    en: enMessages,
  },
});

const setCorei18nLocale = (languageLocale: string) => {
  // TODO - Find out how to change language in Vue3
  // i18n.global.locale = languageLocale;
  languageLocale.toString();
};

const setCorei18nLocalMessage = (langLocale: string, messages: any) =>
  i18n.global.setLocaleMessage(langLocale, messages);

const corei18nt = (keyString: string, values?: Record<string, any>) =>
  values ? i18n.global.t(keyString, values) : i18n.global.t(keyString);

export const i18nCore = {
  setCorei18nLocale,
  setCorei18nLocalMessage,
  corei18nt,
};

// END OF VUE 3 */
